'use strict';
import * as $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00244 from "./app.data.-Cookie-App-Auth-Data$-For-Org-Member$$anon$4.js";
import * as $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00246 from "./app.data.-Cookie-App-Auth-Data$-For-Org-Member$$anon$6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_CookieAppAuthData$ForOrgMember$() {
  this.aAs = null;
  this.aAt = false;
  this.aAu = null;
  this.aAv = false;
}
export { $c_Lapp_data_CookieAppAuthData$ForOrgMember$ as $c_Lapp_data_CookieAppAuthData$ForOrgMember$ };
$p = $c_Lapp_data_CookieAppAuthData$ForOrgMember$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_CookieAppAuthData$ForOrgMember$;
/** @constructor */
function $h_Lapp_data_CookieAppAuthData$ForOrgMember$() {
}
export { $h_Lapp_data_CookieAppAuthData$ForOrgMember$ as $h_Lapp_data_CookieAppAuthData$ForOrgMember$ };
$h_Lapp_data_CookieAppAuthData$ForOrgMember$.prototype = $p;
$p.asc = (function() {
  if ((!this.aAt)) {
    this.aAs = new $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00244.$c_Lapp_data_CookieAppAuthData$ForOrgMember$$anon$4();
    this.aAt = true;
  }
  return this.aAs;
});
$p.asd = (function() {
  if ((!this.aAv)) {
    this.aAu = new $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData$0024$002dFor$002dOrg$002dMember$0024$0024anon$00246.$c_Lapp_data_CookieAppAuthData$ForOrgMember$$anon$6();
    this.aAv = true;
  }
  return this.aAu;
});
var $d_Lapp_data_CookieAppAuthData$ForOrgMember$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_CookieAppAuthData$ForOrgMember$, "app.data.CookieAppAuthData$ForOrgMember$", ({
  D6: 1
}));
export { $d_Lapp_data_CookieAppAuthData$ForOrgMember$ as $d_Lapp_data_CookieAppAuthData$ForOrgMember$ };
var $n_Lapp_data_CookieAppAuthData$ForOrgMember$;
function $m_Lapp_data_CookieAppAuthData$ForOrgMember$() {
  if ((!$n_Lapp_data_CookieAppAuthData$ForOrgMember$)) {
    $n_Lapp_data_CookieAppAuthData$ForOrgMember$ = new $c_Lapp_data_CookieAppAuthData$ForOrgMember$();
  }
  return $n_Lapp_data_CookieAppAuthData$ForOrgMember$;
}
export { $m_Lapp_data_CookieAppAuthData$ForOrgMember$ as $m_Lapp_data_CookieAppAuthData$ForOrgMember$ };
//# sourceMappingURL=app.data.-Cookie-App-Auth-Data$-For-Org-Member$.js.map
